import { CurrencyType } from '@/api/Wallet/Types/Wallet'

export function getCurrencySymbol(type: CurrencyType): string {
  switch (type) {
    case 'GBP':
      return '£'
    case 'EUR':
      return '€'
    case 'PLN':
      return 'zł'
    case 'USD':
      return '$'
    case 'CHF':
      return '₣'
    default:
      return type
  }
}
